import Vue from 'vue';
import toastVue from './toast';

const el = document.createElement('div');
document.body.appendChild(el);
export default (msg) => {
    const Toast = Vue.extend({
        template:"<toastVue :msg='msg'></toastVue>",
        data() {
            return {
                msg,
            };
        },
        components:{
            toastVue
        }
    });
    new Toast().$mount(el);
    return Toast;
};




// WEBPACK FOOTER //
// ./src/components/ToastMtd/index.js